import React from 'react';
import {
  PRODUCE_STRING,
  TP_NO_SECONDS_FORMAT,
} from './constants';
import moment from 'moment';
import PropTypes from 'prop-types';
import { finalValuesCases } from './functions';
import { KeyboardTimePicker } from '@material-ui/pickers';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

/**
 *
 *  format: permite especificar el formato con que se mostrarán las fechas
 *  por defecto se utiliza HH:mm:ss
 */

function TimePickerBase({
  row,
  label,
  field,
  format,
  produces,
  onChangeProps,
  form: {
    errors,
    touched,
    setFieldValue,
    setFieldTouched,
    ...form
  },
  field: { name, value },
  ...rest
}) {
  const hasError = touched[name] && Boolean(errors[name]);
  return (
    <KeyboardTimePicker
      autoOk
      fullWidth
      name={name}
      label={label}
      margin="dense"
      error={hasError}
      okLabel="Aceptar"
      autoComplete="off"
      clearLabel="Limpiar"
      cancelLabel="Cancelar"
      inputVariant="outlined"
      animateYearScrolling={false}
      keyboardIcon={<AccessTimeIcon />}
      helperText={hasError && errors[name]}
      value={value ? moment(value, 'HH:mm') : value}
      onChange={(valueToSet) => {
        let finalValue = valueToSet;
        if (valueToSet) {
          finalValue = finalValuesCases(finalValue, produces, format);
        }
        setFieldTouched(name, true);
        setFieldValue(name, finalValue);
        if (onChangeProps) {
          onChangeProps(finalValue, form, row);
        }
      }}
      {...rest}
    />
  );
}

TimePickerBase.defaultProps = {
  label: '',
  produces: PRODUCE_STRING,
  format: TP_NO_SECONDS_FORMAT,
};

TimePickerBase.propTypes = {
  produces: PropTypes.string,
  label: PropTypes.string,
  row: PropTypes.oneOfType([PropTypes.object]),
  field: PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.instanceOf(moment),
      PropTypes.string,
    ]),
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  format: PropTypes.string,
  form: PropTypes.shape({
    errors: PropTypes.shape(),
    touched: PropTypes.shape(),
    setFieldTouched: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
  }).isRequired,
  onChangeProps: PropTypes.func,
};

export default TimePickerBase;
